import client from '/src/services/client.js';

export default {
    getLogs: (data) => client.get('admin/logs', data),
}
